import React from 'react';
import Rodal from 'rodal';
import { func, bool, string, oneOfType, arrayOf, node } from 'prop-types';
import styled from 'styled-components';

import { CloseIcon } from '../CloseIcon';

export const Modal = ({ children, isVisible, title, onClose, animation, className, isHeaderless }) => {
  return (
    <Rodal
      visible={isVisible}
      onClose={onClose}
      animation={animation}
      showCloseButton={false}
      customStyles={{
        width: 'auto',
        height: 'auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'transparent',
        overflow: 'visible',
      }}
    >
      <Container className={className}>
        {!isHeaderless && (
          <Header>
            <Title>{title}</Title>
            <CloseIcon clickHandler={onClose} />
          </Header>
        )}
        {children}
      </Container>
    </Rodal>
  );
};

Modal.propTypes = {
  isVisible: bool.isRequired,
  onClose: func.isRequired,
  children: oneOfType([arrayOf(node), node]).isRequired,
  animation: string,
  className: string,
  title: string.isRequired,
  isHeaderless: bool,
};

Modal.defaultProps = {
  animation: 'fade',
  className: '',
  isHeaderless: false,
};

const Container = styled.div`
  max-height: 80rem;
  padding: 3.6rem;
  flex-direction: column;
  justify-content: space-between;
  background-color: ${(props) => props.theme.colors.white};
  border-radius: 1.2rem;
  box-shadow: 0 3px 32px rgba(0, 0, 0, 0.14);
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Title = styled.h3`
  font-size: 2rem;
  font-weight: bold;
  color: ${(props) => props.theme.colors.darkBlue};
`;
